export type AppTheme = "light" | "dark";

const STORAGE_KEY = "theme";

export function getStoredTheme(): AppTheme {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(theme: AppTheme): void {
  const isDark = theme === "dark";
  document.body.classList.toggle("dark", isDark);
  document.body.classList.toggle("dark-skin", isDark);
  document.body.classList.toggle("light", !isDark);
  document.documentElement.dataset.theme = theme;

  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* storage unavailable */
  }
}

export function initTheme(): AppTheme {
  const theme = getStoredTheme();
  applyTheme(theme);
  return theme;
}

export function toggleThemeValue(current: AppTheme): AppTheme {
  return current === "dark" ? "light" : "dark";
}
